/*
 * hp-partner-k13.js -- autoplay spoustec pro tri video polaroidy v sekci
 * Spoluprace na HP (task AW3 KOREKCE, majitel "chtel jsem tenhle efekt
 * a fotky ze showreelu"). VLASTNI SOUBOR/BLOK (task AW pozadavek "JS
 * efektu -- samostatny soubor/blok, ne index.js lightbox"), importovany
 * do `index.js` stejnym vzorem jako ostatni moduly F0.5 (try/catch,
 * vlastni init()) -- bundl zustava JEDEN (kontrakt A7), jen zdroj je
 * ve vlastnim souboru.
 *
 * CO DELA: entrance/houpani/pilulka jsou CISTE CSS keyframes
 * (`assets/css/hp2026.css`, trida `.k13in` na `.partner`). Tenhle modul
 * ma DVE odpovednosti, obe nejde udelat v CSS:
 *
 *   1. Prida `.k13in` na `<section class="partner">` PRI PRVNIM vstupu
 *      do viewportu (IntersectionObserver, jednou -- `unobserve` po
 *      spusteni), aby entrance/houpani/pilulka nezacaly hned pri
 *      nacteni stranky, kdyz sekce muze byt hluboko pod ohybem.
 *   2. Skutecne SPUSTI prehravani `<video preload="none">` (CSS samo
 *      video nespusti) -- `video.load()` + `video.play()` az po vstupu
 *      do viewportu, aby se pod 900 px / pri `prefers-reduced-motion`
 *      nikdy nestahoval ani nehral jediny byte (brana "reduced-motion
 *      0 prehravani" + "media budget").
 *
 * PREFERS-REDUCED-MOTION: modul se pro takove uzivatele VUBEC nespusti
 * -- `.k13in` se neprida (CSS zustava na statickem klidovem stavu,
 * pilulka ukazuje jen prvni napis), video se nenacte ani nezacne hrat.
 * Fail-open (D4): bez podpory IntersectionObserver se nic nerozbije,
 * jen se efekt/autoplay nikdy nespusti -- poster zustava viditelny.
 */

/**
 * @return {void}
 */
export function init() {
	if ( typeof window === 'undefined' || typeof document === 'undefined' ) {
		return;
	}

	let reduceMotion = false;

	try {
		reduceMotion = !! ( window.matchMedia && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches );
	} catch ( matchMediaError ) {
		void matchMediaError;
	}

	if ( reduceMotion ) {
		return;
	}

	const groups = document.querySelectorAll( '.partner .ppolaroids[data-k13]' );

	if ( ! groups.length || typeof window.IntersectionObserver !== 'function' ) {
		return;
	}

	const io = new window.IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( ! entry.isIntersecting ) {
					return;
				}

				const group = entry.target;
				const section = group.closest( '.partner' );

				if ( section ) {
					section.classList.add( 'k13in' );
				}

				const videos = group.querySelectorAll( 'video.pvideo' );

				videos.forEach( ( video ) => {
					const figure = video.closest( '.polaroid' );

					if ( figure ) {
						figure.classList.add( 'playing' );
					}

					try {
						video.load();
						const playPromise = video.play();

						if ( playPromise && typeof playPromise.catch === 'function' ) {
							playPromise.catch( () => {
								/* Autoplay policy nebo pomaly download -- poster zustava, nic se nerozbije. */
							} );
						}
					} catch ( playError ) {
						void playError;
					}
				} );

				io.unobserve( group );
			} );
		},
		{ threshold: 0.35 }
	);

	groups.forEach( ( group ) => {
		io.observe( group );
	} );
}
